module.exports = __webpack_public_path__ + "static/media/page-monster-unplug.349b042c.png";